import { Spacing, Title } from '@vkontakte/vkui';
import React, { type Dispatch, type SetStateAction, memo, useCallback } from 'react';
import type { AiPhotoGenerationImageStyleType } from 'reactApp/modules/aiPhotoGeneration/aiPhotoGeneration.types';
import { AiPhotoGenerationStylesGrid } from 'reactApp/ui/AiPhotoGeneration/Modals/Styles/AiPhotoGenerationStylesGrid';
import { Dialog } from 'reactApp/ui/Dialog/Dialog';
import { sendXray } from 'reactApp/utils/ga';
import { ECategoryGa, sendPaymentGa } from 'reactApp/utils/paymentGa';

import styles from './AiPhotoGenerationStylesPopup.css';

export interface IAiPhotoGenerationStylesPopup {
    setSelectedStyle: Dispatch<SetStateAction<AiPhotoGenerationImageStyleType | null>>;
    onClose?: () => void;
}

const handleShow = () => {
    sendXray(['ai-gen', 'styles-menu', 'show']);
    sendPaymentGa({
        eventCategory: ECategoryGa.aiPhotoGeneration,
        action: 'styles-menu-show',
        dwh_enabled: true,
        dwh_enabled_fields: [['paid_user', 'corp_user']],
    });
};

export const AiPhotoGenerationStylesPopup = memo<IAiPhotoGenerationStylesPopup>(({ setSelectedStyle, onClose }) => {
    const onStyleClick = useCallback(
        (style: AiPhotoGenerationImageStyleType) => {
            setSelectedStyle(style);
            onClose?.();
            sendPaymentGa({
                eventCategory: ECategoryGa.aiPhotoGeneration,
                action: 'styles-menu-choose',
                generation_style: style,
                dwh_enabled: true,
                dwh_enabled_fields: [['paid_user', 'corp_user', 'style']],
            });
        },
        [setSelectedStyle, onClose]
    );

    const handleClose = useCallback(() => {
        onClose?.();
        sendPaymentGa({
            eventCategory: ECategoryGa.aiPhotoGeneration,
            action: 'styles-menu-close',
            dwh_enabled: true,
            dwh_enabled_fields: [['paid_user', 'corp_user']],
        });
    }, [onClose]);

    return (
        <Dialog
            open
            id="ai-generation-styles"
            onCancel={handleClose}
            onShow={handleShow}
            className={styles.modal}
            theme="dark"
            closeIconWrapperClassName={styles.closeIcon}
        >
            <div className={styles.wrapper}>
                <Title level="1">Стили</Title>
                <Spacing size={16} />
                <AiPhotoGenerationStylesGrid onClick={onStyleClick} />
            </div>
        </Dialog>
    );
});

AiPhotoGenerationStylesPopup.displayName = 'AiPhotoGenerationStylesPopup';
